import { Routing } from "helpers/routing";
import Reac, { createContext } from "react";

const TeamDatasourceIdentifierContext = createContext<{
  params?: Routing.TeamDatasourceIdentifierParams
}>({})

export { TeamDatasourceIdentifierContext }
